import { render, staticRenderFns } from "./stacked-outlook.vue?vue&type=template&id=7dc0a298&scoped=true&"
import script from "./stacked-outlook.vue?vue&type=script&lang=js&"
export * from "./stacked-outlook.vue?vue&type=script&lang=js&"
import style0 from "./stacked-outlook.vue?vue&type=style&index=0&id=7dc0a298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0a298",
  null
  
)

export default component.exports